import React, {Component} from 'react';
import {Form, Input, Select, Modal, Button, Table, Icon, message, Radio} from 'antd';
import {Redirect} from 'react-router';
import ReactQuill, {Quill} from 'react-quill';//富文本编辑器(react-quill)
import {ImageDrop} from 'quill-image-drop-module';
import 'react-quill/dist/quill.snow.css'; // ES6
import utils from '../../../utils/common';
import UploadBox from '../../../components/backEnd/uploadBox';
import StepsModel from '../../../components/backEnd/steps';

const Option = Select.Option;
const RadioGroup = Radio.Group;
Quill.register('modules/imageDrop', ImageDrop);
class EditGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      currentStep: 1,
      uploadBoxVisible: false,
      uploadUrl: '',
      selectData: [],
      goodsList: [],
      type: 0, //区分是否显示复选框
      form: {
        package_name: '', //套餐名称
        goods_list: [], //套餐商品
        package_amt: '', //套餐价格
        procurement_level: '', //套餐等级
        package_is_post: '', //不需要
        package_picture: '', //套餐图片
        package_details: '' //套餐详情
      },
      selectedRowKeys: '',
      pagination: {
        hideOnSinglePage: true
      }
    };
  }
  modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{header: 1}, {header: 2}],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{script: 'sub'}, {script: 'super'}],
        [{indent: '-1'}, {indent: '+1'}],
        [{direction: 'rtl'}],
        [{header: [1, 2, 3, 4, 5, 6, false]}],
        [{color: []}, {background: []}],
        [{font: []}],
        [{align: []}],
        ['link', 'image', 'video'],
        ['clean']
      ],
      handlers: {
        image: this.showUploadBox.bind(this)
      }
    },
    imageDrop: true
  }
  componentWillMount() {
    const locaState = this.props.location.state;
    if (!locaState) return false;
    this.setState({type: locaState.type});
    if (locaState.type === 0) {
      const arr = this.setAmout(locaState.params.selectData);
      this.setState({selectData: locaState.params.selectData, goodsList: arr});
    } else {
      this.initForm(locaState.id);
    }
  }
  setAmout(arr) {
    const data = [];
    arr.map(item => {
      const id = this.state.type === 0 ? item.id : item.goods_id;
      const amount = item.goods_amount === undefined ? 1 : item.goods_amount;
      data.push({goods_id: id, goods_amount: amount});
    });
    return data;
  }
  initForm = (id) => {
    window.api('eps.getgoodspackageinfo', {id}).then(rs => {
      const packageList = rs.goods_package;
      const arr = this.setAmout(packageList.goods_package_detail_list);
      const form = {
        package_name: packageList.package_name,
        package_amt: packageList.package_amt,
        procurement_level: Number(packageList.procurement_level),
        package_is_post: Number(packageList.package_is_post),
        package_picture: packageList.package_picture,
        package_details: packageList.package_details,
        goods_list: packageList.goods_package_detail_list
      };
      const selectedRowKeys = [];
      packageList.goods_package_detail_list.map(item => {
        selectedRowKeys.push(item.goods_id);
      });
      this.setState({
        form,
        selectData: packageList.goods_package_detail_list,
        goodsList: arr,
        selectedRowKeys
      });
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
    });
  }
  // 上传图片
  uploadImgEvent = (e) => {
    e.preventDefault();
    const info = e.target.files[0];
    if (!info) return false;
    const reader = new FileReader();
    reader.readAsDataURL(info);
    const flag = window.common.beforeUpload(info, message); //上传之前判断图片大小
    const _this = this;
    if (flag === true) {
      reader.onload = function () {
        const params = {pic_name: info.name, goods_pic: this.result};
        window.api('eps.upload', params).then(rs => {
          if (_this.state.uploadBoxVisible === true) {
            _this.setState({uploadUrl: rs.pic_path});
          } else {
            const form = Object.assign(_this.state.form, {package_picture: rs.pic_path});
            //_this.props.form.setFieldsValue({package_picture: rs.pic_path});
            _this.setState({form});
          }
        }).catch(error => {
          if (error.service_error_code === 'EPS000000801') {
            this.setState({redirect: true});
          }
          message.error(error.service_error_message);
        });
      };
    }
  }
  handleUpload = () => {
    if (typeof this.reactQuillRef.getEditor !== 'function') return;
    if (this.state.uploadUrl === '') {
      message.error('请先上传图片');
      return false;
    }
    const quill = this.reactQuillRef.getEditor();
    const range = quill.getSelection();
    const index = range ? range.index : 0;
    quill.insertEmbed(index, 'image', this.state.uploadUrl, Quill.sources.USER);//插入图片
    quill.setSelection(index + 1);//光标位置加1
    this.hideUploadBox();
  }
  changeDetailEvent = (value) => {
    const form = Object.assign(this.state.form, {package_details: value});
    this.setState({form});
  }
  changeForm = (type, e) => {
    const form = Object.assign(this.state.form, {package_is_post: e.target.value});
    this.setState({form});
  }
  addPackageEvent = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.state.form.package_picture === '') {
          message.error('请先上传图片');
          return false;
        }
        if (this.state.form.package_details === '') {
          message.error('请填写套餐介绍');
          return false;
        }
        let form = Object.assign(values, {
          package_picture: this.state.form.package_picture,
          package_details: this.state.form.package_details
        });
        let type = '';
        if (this.props.location.state.type === 0) {
          form = Object.assign(form, {goods_list: JSON.stringify(this.state.goodsList)});
          type = 'eps.creategoodspackage';
        } else {
          type = 'eps.modgoodspackage';
          const arr = [];
          this.state.goodsList.map(item => {
            arr.push({goods_id: item.goods_id, goods_amount: item.goods_amount});
          });
          form = Object.assign(form, {package_id: this.props.location.state.id, goods_list: JSON.stringify(arr)});
        }
        form = utils.dealElement(form);
        window.api(type, form).then(rs => {
          this.setState({currentStep: 2});
          message.success(rs.service_error_message);
          this.props.history.push('/main/packagelist');
        }).catch(error => {
          if (error.service_error_code === 'EPS000000801') {
            this.setState({redirect: true});
          }
          message.error(error.service_error_message);
        });
      }
    });
  }
  prevToEvent = () => {
    window.localStorage.setItem('locaParams', JSON.stringify(this.props.location.state.params));
    window.history.go(-1);
  }
  showUploadBox() {
    this.setState({uploadBoxVisible: true, uploadUrl: ''});
  }
  hideUploadBox = () => {
    this.setState({uploadBoxVisible: false});
  }
  changeNumEvent = (item, index, e) => {
    const numberData = this.state.goodsList;
    if (e.target.value > Number(item.goods_num)) {
      message.warning(`数量不能超过${item.goods_num}`);
      numberData[index].goods_amount = item.goods_num;
    }
    if (e.target.value < 1) {
      message.warning('数量不能小于1');
      numberData[index].goods_amount = 1;
    }
    numberData[index].goods_amount = e.target.value;
    this.setState({goodsList: numberData});
  }
  //控制数量加减
  numberSquareEvent = (item, type, index) => {
    const numberData = this.state.goodsList;
    let amount = numberData[index].goods_amount;
    if (type === 'plus') {
      if ((amount++) >= item.goods_num) {
        message.warning('已是最大库存');
        return false;
      }
    } else {
      if (amount <= 1) {
        message.warning('数量不能小于1');
        return false;
      }
      amount--;
    }
    numberData[index].goods_amount = amount;
    this.setState({goodsList: numberData});
  }
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const form = Object.assign(this.state.form, {goods_list: selectedRows});
    this.setState({selectedRowKeys, form});
  }
  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      form,
      redirect,
      selectData,
      uploadBoxVisible,
      currentStep,
      pagination,
      goodsList,
      selectedRowKeys
    } = this.state;
    const columns = [
      {
        title: '商品名称',
        key: 'goods_name',
        dataIndex: '',
        render: (record) => (
          <div>{record.goods_name}</div>
        )
      },
      {
        title: '商品单价',
        key: 'sale_price',
        dataIndex: 'sale_price'
      },
      {
        title: '库存',
        key: 'goods_num',
        dataIndex: 'goods_num'
      },
      {
        title: '数量',
        key: 'number',
        dataIndex: '',
        render: (text, record, index) => (
          <div className="number-square">
            <Icon type="minus-square" className="square-ico" onClick={this.numberSquareEvent.bind(this, record, 'minus', index)} />
            <Input style={{width: '50px'}} value={goodsList[index].goods_amount} onChange={this.changeNumEvent.bind(this, record, index)} />
            <Icon type="plus-square" className="square-ico" onClick={this.numberSquareEvent.bind(this, record, 'plus', index)} />
          </div>
        )
      }
    ];
    if (redirect) return (<Redirect to="/login" />);
    /*const rowSelection = this.state.type === 1 ? {
      onChange: this.onSelectChange,
      selectedRowKeys: this.state.selectedRowKeys,
      getCheckboxProps: (record) => ({
        defaultChecked: selectedRowKeys.includes(`${record.goods_id}`)
      }),
    } : null;*/
    const rowSelection = null;
    const pageTitle = this.props.location.state.type === 0 ? '新建套餐' : '编辑套餐';
    return (
      <div className="package-blocks edit-goods-page">
        {
          this.props.location.state.type === 0 ? <StepsModel currentStep={currentStep} /> : null
        }
        <div className="edit-goods-header">
          {/* <Button type="primary" onClick={this.prevToEvent.bind(this)}> <Icon type="left" />返回</Button> */}
          <div className="edit-goods-header-text">
            <h1 className="edit-goods-title">{pageTitle}</h1>
            <p className="edit-goods-desc">填写套餐基本信息与商品组合</p>
          </div>
        </div>
        <Form onSubmit={this.addPackageEvent} className="form-items mt30 edit-goods-form" name="form" id="form">
          <section className="form-section">
            <h2 className="form-section-title">基本信息</h2>
            <Form.Item label="套餐名称">
              {
                getFieldDecorator(
                  'package_name',
                  {
                    initialValue: form.package_name || '',
                    rules: [
                      {required: true, message: '请输入套餐名称'}
                    ]
                  }
                )(<Input placeholder="请输入套餐名称" className="input-md" />)
              }
            </Form.Item>
            <Form.Item label="所选商品组合">
              <div className="table edit-goods-table-wrap">
                <Table
                  columns={columns}
                  dataSource={selectData}
                  rowKey={record => record.id}
                  rowSelection={rowSelection}
                  pagination={pagination}
                  size="small"
                />
              </div>
            </Form.Item>
            <div className="form-row-inline">
              <Form.Item label="设置套餐价格" className="form-item-with-suffix">
                {
                  getFieldDecorator(
                    'package_amt',
                    {
                      initialValue: form.package_amt || '',
                      rules: [
                        {required: true, message: '请设置套餐价格'},
                        {pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)'}
                      ]
                    }
                  )(<Input placeholder="0.00" className="input-price" />)
                }
                <span className="input-suffix">元</span>
              </Form.Item>
              <Form.Item label="购买可升级为">
                {
                  getFieldDecorator(
                    'procurement_level',
                    {
                      initialValue: form.procurement_level,
                      rules: [
                        {required: true, message: '请选择等级'}
                      ]
                    }
                  )(<Select placeholder="请选择等级" className="select-md">
                    <Option value="" key="">全部</Option>
                    {
                      window.common.levelData.map((item, index) => (
                        <Option value={index} key={index}>{item}</Option>
                      ))
                    }
                  </Select>)
                }
              </Form.Item>
              <Form.Item label="套餐是否发货">
                {getFieldDecorator(
                  'package_is_post',
                  {
                    initialValue: form.package_is_post,
                    rules: [
                      {required: true, message: '请选择是否发货'}
                    ]
                  }
                )(<RadioGroup onChange={this.changeForm.bind(this, 'package_is_post')} className="radio-group-md">
                  <Radio value={0}>是</Radio>
                  <Radio value={1}>否</Radio>
                </RadioGroup>)
                }
              </Form.Item>
            </div>
          </section>
          <section className="form-section">
            <h2 className="form-section-title">套餐展示</h2>
            <Form.Item label={<span><em className="required-star">*</em>套餐图片</span>}>
              <div className="upload-blocks upload-package-pic">
                <div className="file-items">
                  <input type="file" accept="image/jpg,image/jpeg,image/png,image/bmp" onChange={this.uploadImgEvent} ref="file" name="file" className="valid coverfile" />
                  <img src={form.package_picture} alt="" className={`show-pic ${form.package_picture === '' ? 'hide' : ''}`} />
                  <div className="adImgUrl">
                    <span className="rc-upload coverbutton" role="button">
                      <i className="anticon anticon-plus">+</i>
                      <div className="ant-upload-text">上传商品图</div>
                    </span>
                  </div>
                  <div className="ant-upload-list-item-info v-img-box ad_p_img">
                    <i className="icon-close anticon-delete voucherImgIcon" />
                  </div>
                </div>
              </div>
            </Form.Item>
            <Form.Item label={<span><em className="required-star">*</em>套餐介绍</span>}>
              <div className="quill-editor-wrap">
                <ReactQuill
                  placeholder="请输入商品描述详情"
                  theme="snow"
                  style={{minHeight: 300}}
                  onChange={this.changeDetailEvent}
                  value={form.package_details}
                  modules={this.modules}
                  ref={(el) => { this.reactQuillRef = el; }}
                />
              </div>
              <Modal
                title="上传图片"
                visible={uploadBoxVisible}
                onCancel={this.hideUploadBox}
                onOk={this.handleUpload}
                maskClosable={false}
                width={500}
              >
                <UploadBox changeImageBeforeUpload={this.uploadImgEvent} src={this.state.uploadUrl} />
              </Modal>
            </Form.Item>
          </section>
          <div className="button-tap">
            <Form.Item>
              <Button onClick={this.prevToEvent.bind(this)} className="btn-secondary">上一步</Button>
              <Button type="primary" htmlType="submit" className="btn-primary-submit">完成</Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }
}
export default Form.create()(EditGoods);



// WEBPACK FOOTER //
// ./src/containers/backEnd/packageMangement/editgoods.jsx